import React, { useEffect, useState } from "react";
import { Box, IconButton, Typography, CircularProgress, Alert } from "@mui/material";
import { ArrowBack as ArrowBackIcon } from "@mui/icons-material";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import {
    productConversionService,
    ProductConversion,
} from "../../services/productConversionService";
import { ConversionDetailContent } from "../../components/conversions/ConversionDetailContent";

const ViewConversion: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const location = useLocation();
    const backTo =
        (location.state as { from?: string } | null)?.from ||
        "/inventory/conversions";

    const [conversion, setConversion] = useState<ProductConversion | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        if (!id) return;
        setLoading(true);
        productConversionService
            .getConversion(id)
            .then(setConversion)
            .catch(() => setError("Failed to load conversion"))
            .finally(() => setLoading(false));
    }, [id]);

    return (
        <Box sx={{ p: { xs: 0, sm: 3 } }}>
            <Box display="flex" alignItems="center" mb={3}>
                <IconButton onClick={() => navigate(backTo)} sx={{ mr: 1 }}>
                    <ArrowBackIcon />
                </IconButton>
                <Typography
                    variant="h4"
                    component="h1"
                    sx={{ fontSize: { xs: "1.35rem", sm: "2.125rem" } }}
                >
                    Conversion {conversion?.conversion_number || ""}
                </Typography>
            </Box>

            {loading && (
                <Box display="flex" justifyContent="center" py={6}>
                    <CircularProgress />
                </Box>
            )}
            {!loading && error && <Alert severity="error">{error}</Alert>}
            {!loading && conversion && (
                <ConversionDetailContent conversion={conversion} />
            )}
        </Box>
    );
};

export default ViewConversion;
